import React, { useState } from "react";
import "./assets/styles/LandingPage.css";
import logoEs from "./assets/images/logoSnapOk.png";
import logoPt from "./assets/images/logoSnapPT-bg.png";
import logoEn from "./assets/images/logoSnapEN-bg.png";
import { Helmet } from "react-helmet-async";
import FooterInstitucional from "./Components/FooterInstitucional/FooterInstitucional";
import { translationsLanding } from "./translationsLanding";
import { faqContent } from "./translationsFAQ";
import axios from "axios";

const API_SEND_EMAIL = "https://sendcontactemail-614540036899.us-central1.run.app";

function LandingPage() {
  const lang = navigator.language.split("-")[0];
  const [formStatus, setFormStatus] = useState("idle");
  const [openFaq, setOpenFaq] = useState(null);

  const faq = faqContent[lang] || faqContent["en"]; // idle | sending | sent | error

  let logo;
  if (lang === "pt") logo = logoPt;
  else if (lang === "es") logo = logoEs;
  else logo = logoEn;

  const t = translationsLanding[lang] || translationsLanding["en"];

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setFormStatus("sending");
    const form = e.target;
    try {
      await axios.post(API_SEND_EMAIL, {
        name: form.elements["name"].value,
        email: form.elements["email"].value,
        message: form.elements["message"].value,
      });
      setFormStatus("sent");
      form.reset();
    } catch (err) {
      console.error("Error sending email:", err);
      setFormStatus("error");
    }
  };

  return (
    <div className="landing">
      <Helmet>
        <title>{t.title}</title>
      </Helmet>

      {/* HERO */}
      <section className="landing__hero">
        <div className="landing__hero-content">
          <img src={logo} alt="Snap Moments" className="landing__logo" />
          <h1 className="landing__headline">{t.welcome}</h1>
          <p className="landing__sub">{t.paragraph1}</p>
          <a href="https://wa.me/5493795003578" target="_blank" rel="noreferrer" className="landing__cta">
            <i className="fab fa-whatsapp"></i> {t.ctaText || "Contactanos"}
          </a>
        </div>
        <div className="landing__hero-visual">
          <div className="landing__hero-collage">
            <img src="https://images.unsplash.com/photo-1519741497674-611481863552?w=400&h=520&fit=crop" alt="Wedding" className="landing__collage-img landing__collage-img--1" />
            <img src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=300&h=300&fit=crop" alt="Celebration" className="landing__collage-img landing__collage-img--2" />
            <img src="https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=300&h=300&fit=crop" alt="Party" className="landing__collage-img landing__collage-img--3" />
          </div>
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <section className="landing__proof">
        <div className="landing__proof-item">
          <i className="fas fa-camera"></i>
          <span>+2,500</span>
          <p>{lang === "es" ? "fotos subidas" : lang === "pt" ? "fotos enviadas" : "photos uploaded"}</p>
        </div>
        <div className="landing__proof-item">
          <i className="fas fa-calendar-check"></i>
          <span>+100</span>
          <p>{lang === "es" ? "eventos" : lang === "pt" ? "eventos" : "events"}</p>
        </div>
        <div className="landing__proof-item">
          <i className="fas fa-heart"></i>
          <span>+1,000</span>
          <p>likes</p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="landing__section">
        <h2 className="landing__section-title">{t.howItWorks}</h2>
        <div className="landing__steps">
          {t.steps.map((step, i) => {
            const stepIcons = ["fas fa-qrcode", "fas fa-cloud-upload-alt", "fas fa-images"];
            return (
              <div className="landing__step" key={i}>
                <div className="landing__step-icon">
                  <i className={stepIcons[i]}></i>
                </div>
                <p className="landing__step-text">{step}</p>
              </div>
            );
          })}
        </div>
        {/* <p className="landing__note">
          {lang === "es"
            ? "Recibís cartel QR para el evento, invitación digital para WhatsApp y tarjetas pocket individuales."
            : lang === "pt"
              ? "Você recebe cartaz QR para o evento, convite digital para WhatsApp e cartões pocket individuais."
              : "You receive a QR poster for the event, digital invitation for WhatsApp, and individual pocket cards."}
        </p> */}
      </section>

      {/* EVENT TYPES */}
      <section className="landing__section landing__section--dark">
        <h2 className="landing__section-title landing__section-title--light">
          {lang === "es" ? "Para todo tipo de eventos" : lang === "pt" ? "Para todo tipo de evento" : "For all types of events"}
        </h2>
        <div className="landing__events">
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1519741497674-611481863552?w=500&h=620&fit=crop" alt="Wedding" />
            <span>{lang === "es" ? "Casamientos" : lang === "pt" ? "Casamentos" : "Weddings"}</span>
          </div>
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=500&h=620&fit=crop" alt="XV" />
            <span>{lang === "es" ? "Quinceañeras" : lang === "pt" ? "Debutantes" : "Sweet Fifteens"}</span>
          </div>
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=500&h=620&fit=crop" alt="Corporate" />
            <span>{lang === "es" ? "Corporativos" : lang === "pt" ? "Corporativos" : "Corporate"}</span>
          </div>
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1496337589254-7e19d01cec44?w=500&h=620&fit=crop" alt="Party" />
            <span>{lang === "es" ? "Fiestas" : lang === "pt" ? "Festas" : "Parties"}</span>
          </div>
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&h=620&fit=crop" alt="Tables" />
            <span>{lang === "es" ? "Mesas & Decoración" : lang === "pt" ? "Mesas & Decoração" : "Tables & Decor"}</span>
          </div>
          {/* <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1559223607-a43c990c692c?w=500&h=620&fit=crop" alt="QR" />
            <span>{lang === "es" ? "Álbum con QR" : lang === "pt" ? "Álbum com QR" : "QR Album"}</span>
          </div> */}
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1478146059778-26028b07395a?w=500&h=620&fit=crop" alt="Brindis" />
            <span>{lang === "es" ? "Brindis" : lang === "pt" ? "Brinde" : "Toasts"}</span>
          </div>
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=500&h=620&fit=crop" alt="Recepcion" />
            <span>{lang === "es" ? "Recepciones" : lang === "pt" ? "Recepções" : "Receptions"}</span>
          </div>
          {/* <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1529543544282-ea99407407c1?w=500&h=620&fit=crop" alt="Baile" />
            <span>{lang === "es" ? "Baile & Pista" : lang === "pt" ? "Pista de Dança" : "Dance Floor"}</span>
          </div>
          <div className="landing__event-card">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=620&fit=crop&crop=faces" alt="Graduacion" />
            <span>{lang === "es" ? "Graduaciones" : lang === "pt" ? "Formaturas" : "Graduations"}</span>
          </div> */}
        </div>
      </section>

      {/* BENEFITS */}
      <section className="landing__section landing__section--warm">
        <h2 className="landing__section-title">{t.benefitsTitle}</h2>
        <div className="landing__benefits">
          {t.benefits.map((benefit, i) => {
            const icons = ["fas fa-lock", "fas fa-comment-dots", "fas fa-download", "fas fa-shield-alt", "fas fa-tv", "fas fa-cloud"];
            return (
              <div className="landing__benefit" key={i}>
                <i className={icons[i]}></i>
                <p>{benefit}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* CONTACT FORM */}
      <section className="landing__section" id="contacto">
        <h2 className="landing__section-title">
          {lang === "es" ? "Escribinos" : lang === "pt" ? "Fale conosco" : "Contact us"}
        </h2>
        <form className="landing__contact" onSubmit={handleContactSubmit}>
          <input type="text" name="name" placeholder={lang === "es" ? "Tu nombre" : lang === "pt" ? "Seu nome" : "Your name"} required />
          <input type="email" name="email" placeholder={lang === "es" ? "Tu email" : lang === "pt" ? "Seu email" : "Your email"} required />
          <textarea name="message" rows="4" placeholder={lang === "es" ? "Contanos sobre tu evento..." : lang === "pt" ? "Conte-nos sobre seu evento..." : "Tell us about your event..."} required></textarea>
          <button type="submit" disabled={formStatus === "sending"}>
            {formStatus === "sending"
              ? (lang === "es" ? "Enviando..." : lang === "pt" ? "Enviando..." : "Sending...")
              : (<><i className="fas fa-paper-plane" style={{ marginRight: "8px" }}></i>{lang === "es" ? "Enviar mensaje" : lang === "pt" ? "Enviar mensagem" : "Send message"}</>)}
          </button>
          {formStatus === "sent" && (
            <p className="landing__contact-success">
              {lang === "es" ? "¡Mensaje enviado! Te respondemos pronto." : lang === "pt" ? "Mensagem enviada! Respondemos em breve." : "Message sent! We'll reply soon."}
            </p>
          )}
          {formStatus === "error" && (
            <p className="landing__contact-error">
              {lang === "es" ? "Error al enviar. Probá por WhatsApp." : lang === "pt" ? "Erro ao enviar. Tente pelo WhatsApp." : "Error sending. Try WhatsApp."}
            </p>
          )}
        </form>
      </section>

      {/* FAQ ACCORDION */}
      <section className="landing__section" id="faq">
        <h2 className="landing__section-title">{faq.title}</h2>
        <div className="landing__faq">
          {faq.questions.map((item, i) => (
            <div
              className={`landing__faq-item ${openFaq === i ? "open" : ""}`}
              key={i}
            >
              <button
                className="landing__faq-question"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <span>{item.question}</span>
                <i className={`fas fa-chevron-${openFaq === i ? "up" : "down"}`}></i>
              </button>
              {openFaq === i && (
                <div className="landing__faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="landing__final-cta">
        <h2>{lang === "es" ? "¿Listo para tu evento?" : lang === "pt" ? "Pronto para o seu evento?" : "Ready for your event?"}</h2>
        <p>{lang === "es" ? "Escribinos y te armamos tu álbum en minutos." : lang === "pt" ? "Fale conosco e criamos seu álbum em minutos." : "Message us and we'll set up your album in minutes."}</p>
        <a href="https://wa.me/5493795003578" target="_blank" rel="noreferrer" className="landing__cta landing__cta--final">
          <i className="fab fa-whatsapp"></i> {t.ctaText || "Contactanos"}
        </a>
      </section>

      <FooterInstitucional />
    </div>
  );
}

export default LandingPage;